import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React, { useRef } from 'react';
import useDuperbrowseLink from '../hooks/useDuperbrowseLink';
import BiLink from '@wix/da-bi/pkg/Components/BiLink';
import { getDeviationUrl } from '../../DeviationViews/_helpers';
import { useBiDataForDeviationLink } from './useBiDataForDeviationLink';
import { getDeviationEntityId } from '../../redux/normalizr/schemas/deviation';
const DeviationLink = (_param)=>{
    var { deviation, onClick, children, overrideHref, extraBiData, disableScrollRestoration, canLinkToStash = false } = _param, restProps = _object_without_properties(_param, [
        "deviation",
        "onClick",
        "children",
        "overrideHref",
        "extraBiData",
        "disableScrollRestoration",
        "canLinkToStash"
    ]);
    const ref = useRef();
    const linkBiData = useBiDataForDeviationLink(deviation, extraBiData);
    const onDuperbrowseClick = useDuperbrowseLink(getDeviationEntityId(deviation), ref, onClick, disableScrollRestoration);
    if (!deviation.isPublished && !canLinkToStash) {
        return /*#__PURE__*/ React.createElement("span", {
            className: restProps.className,
            style: restProps.style
        }, children);
    }
    return /*#__PURE__*/ React.createElement(BiLink, _object_spread({
        href: overrideHref || getDeviationUrl(deviation),
        biData: linkBiData,
        onClick: onDuperbrowseClick,
        // the undefined here is needed to keep react typings from going nuts
        innerRef: (node)=>ref.current = node || undefined
    }, restProps), children);
};
DeviationLink.displayName = 'DeviationLink';
export default DeviationLink;

//# sourceMappingURL=DeviationLink.js.map